import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class TheRaveGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "rave_countup5";
    static BITMAP_FONT_MULTIPLIER = "rave_countup";
    static BITMAP_FONT_SYMBOL_MULTIPLIER = "rave_countup6";
    static BITMAP_FONT_SUPERFS_GLOW_MUL = "NumbersOpenSans800";
    static BITMAP_FONT_WAYS = "Green_countup_multiplier-export";
    static BITMAP_FONT_FS_INTRO_NUMBER_FS = "rave_countup_fs-export";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapfonts/rave_countup-export.fnt"),
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/rave_countup5-export.fnt"),
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_WAYS, "fonts/bitmapfonts/Green_countup_multiplier-export.fnt"),
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_SYMBOL_MULTIPLIER, "fonts/bitmapfonts/rave_countup6-export.fnt"),
                    new BitmapFontAsset(TheRaveGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS, "fonts/bitmapfonts/rave_countup_fs-export.fnt")
                ]
            },
            {
                name : "backgroundsJpeg",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
             ],
                animations: {}
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    //new TextureAsset("main2", "sheets/main/main2.json")
                ],
                animations: {
                    "shadowDown": "background/shadowDown",
                    "shadowUp": "background/shadowUp",
                    "djAnimationBG":"dj/top_background",
                    "nearwinO": "nearWin/O",
                    "crossfader": "randomFeatureNames/crossfader",
                    "sidechain": "randomFeatureNames/sidechain",
                    "mashup": "randomFeatureNames/mashup",
                    "plusOne": "FS_SFS/+1",
                    "plusTwo": "FS_SFS/+2"
                }
            },
            {
                name : "mainJpeg",
                assets : [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json")
                ],
                animations: {
                    "minBackground": "minBackground",
                    "xWayGlow": "Xway/3xGlow",
                    "pinkEnhance": "smoke/greenHole/greenHole_",
                    "xWayFrame": "Xway/xWayLIGHT/xWayLight_0",
                    "spGlow": "specialGlow/spGlow_00",
                    "xBetReelFrame": "xBetReelFrame/activated_glow_0",
                }
            },
            {
                name : "mainJpegWhite",
                assets : [
                    new TextureAsset("mainJpegWhite0", "sheets/mainJpegWhite/mainJpegWhite0.json")
                ],
                animations : {}
            },
            {
                name : "mainJpegYellow",
                assets : [
                    new TextureAsset("mainJpegYellow0", "sheets/mainJpegYellow/mainJpegYellow0.json"),
                    new TextureAsset("mainJpegYellow1", "sheets/mainJpegYellow/mainJpegYellow1.json"),
                    new TextureAsset("mainJpegYellow2", "sheets/mainJpegYellow/mainJpegYellow2.json"),
                    new TextureAsset("mainJpegYellow3", "sheets/mainJpegYellow/mainJpegYellow3.json")
                ],
                animations : {}
            },
            {
                name : "symbolsHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbolsHighQuality0", "sheets/symbolsHighQuality/symbolsHighQuality0.json")
                ],
                animations : {}
            },
            {
                name : "bigwin",
                assets : [
                    new TextureAsset("bigwin0", "sheets/bigwin/bigwin0.json"),
                    new TextureAsset("bigwin1", "sheets/bigwin/bigwin1.json")
                ],
                animations : {}
            },
            {
                name : "bigwinJpeg",
                assets : [
                    new TextureAsset("bigwinJpeg0", "sheets/bigwinJpeg/bigwinJpeg0.json"),
                    new TextureAsset("bigwinJpeg1", "sheets/bigwinJpeg/bigwinJpeg1.json")
                ],
                animations : {}
            },
            {
                name : "mainHighQuality",
                assets : [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ],
                animations : {}
            },
            {
                name : "symbolsNormalQuality",
                assets : [
                    new TextureAsset("symbolsNormalQuality0", "sheets/symbolsNormalQuality/symbolsNormalQuality0.json")
                ],
                animations : {}
            },
           {
               name : "maxcap",
               assets : [
                   new TextureAsset("maxcap0", "sheets/maxcap/maxcap0.json"),
                   new TextureAsset("maxcap1", "sheets/maxcap/maxcap1.json")
               ],
               animations : {}
           },
            {
               name : "maxcapJpeg",
               assets : [
                   new TextureAsset("maxcapJpeg0", "sheets/maxcapJpeg/maxcapJpeg0.json")
               ],
               animations : {}
           },
            {
                name : "spine",
                assets : [
                    new SpineAsset("bgMAINBlendTop", "spine/background/MAIN/bgBlendTOP.json"),
                    new SpineAsset("bgMAINNormal", "spine/background/MAIN/bgNORMAL.json"),
                    new SpineAsset("bgMAINBlend", "spine/background/MAIN/bgBlend.json"),

                    new SpineAsset("bgFSBlendTop", "spine/background/FS/bgBlendTOP.json"),
                    new SpineAsset("bgFSNormal", "spine/background/FS/bgNORMAL.json"),
                    new SpineAsset("bgFSBlend", "spine/background/FS/bgBlend.json"),

                    new SpineAsset("bgSFSBlend", "spine/background/SFS/bgBlend.json"),
                    new SpineAsset("bgSFSBlendTop", "spine/background/SFS/bgBlendTOP.json"),
                    new SpineAsset("bgSFSNormal", "spine/background/SFS/bgNORMAL.json"),

                    new SpineAsset("individualWin", "spine/initialWin/individual.json"),
                    new SpineAsset("individualShadow", "spine/initialWin/individualShadow.json"),
                    new SpineAsset("L_initialLaser", "spine/initialWin/largeB.json"),
                    new SpineAsset("M_initialLaser", "spine/initialWin/midB.json"),
                    new SpineAsset("S_initialLaser", "spine/initialWin/lowB.json"),
                    new SpineAsset("L_initialWin_frame", "spine/initialWin/LargeMid.json"),
                    new SpineAsset("S_initialWin_frame", "spine/initialWin/low.json"),

                    new SpineAsset("XWAYSnormal", "spine/xWay/XWAYSnormal.json"),
                    new SpineAsset("XWAYSblend", "spine/xWay/XWAYSblend.json"),
                    new SpineAsset("XSHB", "spine/XSHB.json"),
                    new SpineAsset("DJBOOTH_TOP", "spine/DJBOOTH_TOP.json"),

                    new SpineAsset("xSplitBLEND", "spine/xSplit/xSplitBLEND.json"),
                    new SpineAsset("xSplitNORMAL", "spine/xSplit/xSplitNORMAL.json"),

                    new SpineAsset("wildBLEND", "spine/wild/wildBLEND.json"),
                    new SpineAsset("wildNORMAL", "spine/wild/wildNORMAL.json"),
                    new SpineAsset("wildNORMALTOP", "spine/wild/wildNORMALTOP.json"),

                    new SpineAsset("scatterENHANCE", "spine/scatter/SCENHANCE.json"),
                    new SpineAsset("scatterBLEND", "spine/scatter/SCBLEND.json"),
                    new SpineAsset("scatterBLENDTOP", "spine/scatter/SCBLENDtop.json"),
                    new SpineAsset("scatterNORMAL", "spine/scatter/SCNORMAL.json"),
                    new SpineAsset("scatterNORMALTOP", "spine/scatter/SCNORMALtop.json"),
                    new SpineAsset("scatterPinkAttention", "spine/scatter/pinkAttention.json"),
                    new SpineAsset("scatterSMOKE", "spine/scatter/SMOKE.json"),
                    new SpineAsset("scatterAchievement", "spine/scatter/scatterAchievement.json"),

                    new SpineAsset("nearwin", "spine/nearWin/NWnormal.json"),
                    new SpineAsset("nearwinBlend", "spine/nearWin/NWblend.json"),
                    new SpineAsset("spotLight", "spine/scatter/SPOTLIGHT.json"),
                    new SpineAsset("DOWNONE", "spine/FS_FSF/MOVEDOWN/DOWNONE.json"),
                    new SpineAsset("DOWNTWO", "spine/FS_FSF/MOVEDOWN/DOWNTWO.json"),
                    new SpineAsset("SYMTRANSFORM", "spine/SYMTRANSFORM.json"),

                    new SpineAsset("bigwin0BLEND", "spine/BW/level01/L1BLEND.json"),
                    new SpineAsset("bigwin0NORMAL", "spine/BW/level01/L1NORMAL.json"),
                    new SpineAsset("bigwin1BLEND", "spine/BW/level02/L2BLEND.json"),
                    new SpineAsset("bigwin1NORMAL", "spine/BW/level02/L2NORMAL.json"),
                    new SpineAsset("bigwin1NORMAL_US", "spine/BW/level02/L2NORMAL_US.json"),
                    new SpineAsset("bigwin1BLEND_US", "spine/BW/level02/L2BLEND_US.json"),
                    new SpineAsset("bigwin2BLEND", "spine/BW/level03/L3BLEND.json"),
                    new SpineAsset("bigwin2NORMAL", "spine/BW/level03/L3NORMAL.json"),
                    new SpineAsset("bigwin3BLEND", "spine/BW/level04/L4BLEND.json"),
                    new SpineAsset("bigwin3NORMAL", "spine/BW/level04/L4NORMAL.json"),
                    new SpineAsset("bigwin4BLEND", "spine/BW/level05/L5BLEND.json"),
                    new SpineAsset("bigwin4NORMAL", "spine/BW/level05/L5NORMAL.json"),
                    new SpineAsset("bigwin5NORMAL", "spine/BW/level06/L6BLEND.json"),
                    new SpineAsset("bigwin5BLEND", "spine/BW/level06/L6NORMAL.json"),

                    new SpineAsset("textLight", "spine/textLight.json"),
                    new SpineAsset("FSINTRO", "spine/FSINTRO.json"),
                    new SpineAsset("SFSINTRO", "spine/INTRO.json"),
                    new SpineAsset("1T2", "spine/FS_FSF/FRAME/1T2.json"),
                    new SpineAsset("2T3", "spine/FS_FSF/FRAME/2T3.json"),
                    new SpineAsset("3T4", "spine/FS_FSF/FRAME/3T4.json"),
                    new SpineAsset("4T5", "spine/FS_FSF/FRAME/4T5.json"),
                    new SpineAsset("GASBACKGROUND", "spine/FS_FSF/GASBACKGROUND.json"),

                    new SpineAsset("eqGlowBlend", "spine/stackedWild/EQUALIZERGLOW_blend.json"),
                    new SpineAsset("stackedWildBlends", "spine/stackedWild/STACKEDWILD_blend.json"),
                    new SpineAsset("xwaySpotlights", "spine/stackedWild/XWAYSPOTLIGHT.json"),

                    new SpineAsset("maxwin_06", "spine/MAXWIN/06_blend.json"),
                    new SpineAsset("maxwin_05", "spine/MAXWIN/05_normal.json"),
                    new SpineAsset("maxwin_04", "spine/MAXWIN/04_blend.json"),
                    new SpineAsset("maxwin_03", "spine/MAXWIN/03_normal.json"),
                    new SpineAsset("maxwin_02", "spine/MAXWIN/02_blend.json"),
                    new SpineAsset("maxwin_01", "spine/MAXWIN/01_normal.json"),

                    new SpineAsset("wildGlow", "spine/stackedWild/WILDGLOW_blend.json"),
                    new SpineAsset("eqXwayGlow", "spine/stackedWild/XWAYGLOW_blend.json"),
                    new SpineAsset("450wildBlend", "spine/wild/450wildBLEND.json")
                ]
            },
        ]
    };
}